import { MxAutoCompleteFieldProps } from "@rf-l1/form/selects/MxAutoCompleteField/model/MxAutoCompleteField";
import MxSelectOwnersField from "@rf-l1/form/selects/MxSelectOwnerField";
import { useMxFieldControllerContext } from "@rf/context/MxFieldController";
type omit = "value" | "id" | "name" | "testId" | "items" | "onChange";

export type IMxFormSelectOwnerFieldProps = Omit<MxAutoCompleteFieldProps, omit>

const MxFormSelectOwnerField = (props: IMxFormSelectOwnerFieldProps) => {
  const { onChange, onBlur, name, value, invalid, id, inputRef, testId } =
    useMxFieldControllerContext();
  return (
    <MxSelectOwnersField
      {...props}
      name={name}
      id={id}
      inputRef={inputRef}
      onChange={onChange}
      value={value}
      onBlur={onBlur}
      error={invalid}
      testId={testId}
    />
  );
};

export default MxFormSelectOwnerField;
